import { darkTheme, RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { wagmiConfig } from '@shared/configs/wagmi-config';
import { INITIAL_CHAIN } from '@shared/constants/chains';
import { UserInfoProvider } from '@shared/contexts/user-info';
import { WalletsProvider } from '@shared/contexts/wallets-context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { WagmiProvider } from 'wagmi';
import { RouterPathes } from '../constants/router-paths';
import { AppLayout } from '../layouts/app-layout';
import { Home } from '../pages/HomePage';
import { OfferCheckout } from '../pages/OfferCheckoutPage';
import { store } from '../redux/store';

const queryClient = new QueryClient();

const App: FC = () => (
  <>
    <Provider store={store}>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider
            initialChain={INITIAL_CHAIN}
            theme={darkTheme({
              borderRadius: 'small',
              overlayBlur: 'small',
            })}
          >
            <UserInfoProvider>
              <WalletsProvider>
                <BrowserRouter>
                  <Routes>
                    <Route element={<AppLayout />}>
                      <Route
                        path={RouterPathes.home}
                        element={<Home />}
                      />
                      <Route
                        path={RouterPathes.offerCheckout}
                        element={<OfferCheckout />}
                      />
                    </Route>
                  </Routes>
                </BrowserRouter>
              </WalletsProvider>
            </UserInfoProvider>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </Provider>
    <ToastContainer
      position="top-right"
      theme="dark"
      hideProgressBar
      style={{
        top: '40px',
        zIndex: '100',
      }}
    />
  </>
);

export default App;
